import IconTooltipButton from "../../../../button/IconTooltipButton";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export const AddWorkedExampleButton = ({ onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.lc || {}
  );
  return (
    <>
      {id &&
        (permissions?.updated.includes("worked-examples")) && (
          <IconTooltipButton
            title="Add worked example"
            icon={["fas", "file-check"]}
            onClick={onClick}
            color="primary"
            classNameIcon="text-xs "
            style={{
              width: 22,
              height: 22,
              backgroundColor: "#fff",
            }}
          />
        )}
    </>
  );
};

export const UpdateWorkedExampleButton = ({ onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.lc || {}
  );

  return (
    <>
      {id &&
        (permissions?.updated.includes("worked-examples")) && (
          <IconTooltipButton
            title="Update worked example"
            icon={["fas", "edit"]}
            onClick={(we) => onClick(we)}
            style={{
              width: 22,
              height: 22,
              color: "var(--primary)",
            }}
          />
        )}
    </>
  );
};

export const DeleteWorkedExampleButton = ({ onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.lc || {}
  );

  return (
    <>
      {id &&
        (permissions?.updated.includes("worked-examples")) && (
          <IconTooltipButton
            title="Delete worked example"
            icon="trash-alt"
            onClick={(we) => onClick(we)}
            style={{
              width: 22,
              height: 22,
              color: "var(--muted-foreground)",
            }}
          />
        )}
    </>
  );
};


export const AddTeachingSuggestionButton = ({ onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.lc || {}
  );
  return (
    <>
      {id &&
        (permissions?.updated.includes("teaching-suggestion")) && (
          <IconTooltipButton
            title="Add teaching suggestion"
            icon={["fal", "chalkboard-user"]}
            onClick={onClick}
            color="primary"
            classNameIcon="text-xs "
            style={{
              width: 22,
              height: 22,
              backgroundColor: "#fff",
            }}
          />
        )}
    </>
  );
};

export const UpdateTeachingSuggestionButton = ({ onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.lc || {}
  );

  return (
    <>
      {id &&
        (permissions?.updated.includes("teaching-suggestion")) && (
          <IconTooltipButton
            title="Update teaching suggestion"
            icon={["fas", "edit"]}
            onClick={(we) => onClick(we)}
            style={{
              width: 22,
              height: 22,
              color: "var(--primary)",
            }}
          />
        )}
    </>
  );
};

export const DeleteTeachingSuggestionButton = ({ onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.lc || {}
  );

  return (
    <>
      {id &&
        (permissions?.updated.includes("teaching-suggestion")) && (
          <IconTooltipButton
            title="Delete teaching suggestion"
            icon="trash-alt"
            onClick={(we) => onClick(we)}
            style={{
              width: 22,
              height: 22,
              color: "var(--muted-foreground)",
            }}
          />
        )}
    </>
  );
};
